(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('segmentService', segmentService);

    segmentService.$inject = ['$http', 'CONFIG', 'messageService'];

    function segmentService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/segments' ;
        var service = {
            getSegmentByOriginDestiny: getSegmentByOriginDestiny
        }

        return service;

        function getSegmentByOriginDestiny(originId, destinyId, detailed){
            return $http.get(urlBase + "/" + originId + "_" + destinyId + "?detailed=" + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(error){
                    return error;
                });
        }
    }
})();

